import React from 'react';
import { Rect, Text } from 'react-konva';

interface Props {
  id: number;
  x: number;
  y: number;
  width: number;
  height: number;
  color: string;
  name: string;
}
const LightPathDrawing = (props: Props) => {
  const { id, x, y, width, height, color, name } = props;
  return (
    <>
      <Rect
        id={`lightpathdrawing-rect-first-${id}`}
        x={x}
        y={y}
        width={width}
        height={height}
        fill={null}
        stroke={color}
        strokeWidth={3}
        opacity={1}
        shadowEnabled={false}
        dashEnabled={true}
        dash={[5, 2]}
      />
      <Rect
        id={`lightpathdrawing-rect-second-${id}`}
        x={x}
        y={y - 18}
        fill={color}
        opacity={1}
        width={name.length * 8}
        height={17}
      />
      <Text
        id={`lightpathdrawing-text-${id}`}
        x={x + 2}
        y={y - 15}
        fill="white"
        fontSize={15}
        textAnchor="middle"
        text={name}
      ></Text>
    </>
  );
};

export default LightPathDrawing;
